import { useMemo } from 'react'

import { t } from '@/i18n'
import { DealsDealStatusChoices } from '@/apollo/graphql'
import { IOption } from '@/types'

export const useSelect = () => {
  const dealStatusOptions: IOption<DealsDealStatusChoices>[] = useMemo(
    () =>
      Object.entries(DealsDealStatusChoices).map(([k, v]) => ({
        label: t(k),
        value: v,
      })),
    [],
  )

  return {
    dealStatusOptions,
  }
}
